const blogs = {
  portugues: {
    title: 'Blog do bella',
    subTitle: 'Conteúdo exclusivo para todos. Veja os ultimos destaques do nosso blog.',
    searchPlaceholder: 'Pesquise no blog',
    imgDefault: {
      name: 'Nome da Modelo',
      src: 'https://api.belladasemana.com.br/storage/imagens/minhaconta-bg-model.jpg'
    },
    imgBannerRodape: {
      name: 'Nome Banner Rodape',
      src: 'https://api.belladasemana.com.br/storage/banners/1559238886.jpg'
    },
    commentBox: 'Últimos comentários',
    commentBox1: 'Comentários ao vivo',
    commentAllBox: 'Veja todos os comentários',
    commentsBlog: 'comentários',
    feed: 'Assine nosso feed',
    readMore: 'Carregar mais posts',
    seeMoreComment: 'Veja mais',
    seeLessComment: 'Veja menos',
    wroteOn: 'escreveu em',
    share: 'Compartilhe',
    yoursComment: 'Deixe seu comentário',
    yourNickname: 'Seu nickname é',
    notYourNickName: 'não é',
    alterNickName: 'clique aqui para alterar',
    inputComment: 'Escreva seu comentário aqui',
    button: 'Enviar',
    subscriber: 'Assinante',
    formNewsCheck: 'Receber a newsletter do Bella da Semana',
    labelRelated: 'Veja também',
    labelButton: 'Veja mais',
    answer: 'Responder',
    yourName: 'Seu nome',
    yourEmail: 'Seu email',
    publishedDate: 'Publicado em:',
    modifiedDate: 'Última atualização:',
    searchTerm: 'Buscando pelo termo:',
    searchNoRecords: 'Nenhum registro encontrado para o termo informado.',
    watchLive: 'Clique aqui para Assistir a live',
    contagemDias: 'Dias',
    contagemHoras: 'Horas',
    contagemMinutos: 'Minutos',
    contagemRotulo: 'A live começa em {dias} dias, {horas} horas e {minutos} minutos'
  },
  ingles: {
    title: 'BLOG',
    subTitle: 'Exclusive content for everyone. See the latest highlights from our blog.',
    searchPlaceholder: 'Search the blog',
    imgDefault: {
      name: 'Model Name',
      src: 'https://api.belladasemana.com.br/storage/imagens/minhaconta-bg-model.jpg'
    },
    imgBannerRodape: {
      name: 'Nome Banner Rodape',
      src: 'https://api.belladasemana.com.br/storage/banners/1559238886.jpg'
    },
    commentBox: 'Latest comments',
    commentBox1: 'Live comments',
    feed: 'Subscribe to our feed',
    readMore: 'Read more',
    seeMoreComment: 'See more',
    seeLessComment: 'Seeless',
    wroteOn: 'wrote on',
    share: 'Share',
    commentsBlog: 'comments',
    commentAllBox: 'See all comments',
    yoursComment: 'Leave your comment',
    yourNickname: 'Your nickname is',
    notYourNickName: 'Is not',
    alterNickName: 'click here to change',
    inputComment: 'Write your comment here',
    button: 'Send',
    subscriber: 'Subscriber',
    formNewsCheck: 'Receive the Bella Club newsletter',
    labelRelated: 'See too',
    labelButton: 'See more',
    answer: 'Answer',
    yourName: 'Your name',
    yourEmail: 'Your e-mail',
    publishedDate: 'Posted in:',
    modifiedDate: 'Last modified:',
    searchTerm: 'Searching for the term:',
    searchNoRecords: 'No records found for the given term.',
    watchLive: 'Click here to watch live',
    contagemDias: 'Days',
    contagemHoras: 'Hours',
    contagemMinutos: 'Minutes',
    contagemRotulo: 'The live starts in {dias} days, {horas} hours and {minutos} minutes'
  }
}

export default blogs
